import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import formatPrice, { roundUpParser } from '@honda-canada/js-utilities/lib/formatPrice';
import { useTranslation } from 'react-i18next';
import PriceComponent from '../../PriceComponent';
import useSellingPriceConfiguration from '../../PriceComponent/useSellingPriceConfiguration';
import useIsSellingPriceFlag, { SellingPriceFlagSource } from '../hooks/useIsSellingPriceFlag';
import { selectPrimaryCalculatorPaymentOptions } from '../../../core/reducers/financialCalculators';
import { useAppSelector } from '../../../core/utils';
const priceFormatter = (price, language) => formatPrice(price, language, 0, roundUpParser);
const errorComponentStyles = {
    container: {
        marginTop: '36px',
        alignItems: 'flex-start',
    },
    copy: {
        width: '153px',
        fontSize: ['12px', '12px', '12px'],
        lineHeight: ['18px', '18px', '22px'],
        styles: {
            width: 'min-content',
            maxWidth: 'none',
        },
    },
};
const priceComponentStyles = {
    priceStyles: {
        title: {
            size: 'extraSmall',
        },
        copy: {
            styles: {
                fontSize: ['16px', '16px', '18px'],
                lineHeight: ['20px', '20px', '22px'],
            },
        },
    },
    errorStyles: errorComponentStyles,
    pricesContainer: {
        marginBottom: ['36px', '36px', '44px'],
    },
};
const CardPricing = ({ data, error, isFetching, disableMsrp = true, sellingPriceFlagSource = SellingPriceFlagSource.geo, }) => {
    var _a, _b, _c;
    const { t } = useTranslation();
    const allInPrices = { value: (_a = data === null || data === void 0 ? void 0 : data.sellingPrice) === null || _a === void 0 ? void 0 : _a.value, label: t('Shared.Common.sellingPriceLabel') };
    const prices = {
        allInPrice: allInPrices,
        // Ref: SCC-6863 as per the business requirement, the MSRP Price label is not intended to be displayed on the card.
        // For INV, MSRP is still needed, https://hondaca.atlassian.net/browse/SCC-9447
        msrpPrice: !disableMsrp
            ? { value: (_b = data === null || data === void 0 ? void 0 : data.msrp) === null || _b === void 0 ? void 0 : _b.value, label: ((_c = data === null || data === void 0 ? void 0 : data.msrp) === null || _c === void 0 ? void 0 : _c.label) || t('Shared.Common.msrpStartingFromLabel') }
            : allInPrices,
    };
    const isSellingPriceProvince = useIsSellingPriceFlag(sellingPriceFlagSource);
    const { includeFees } = useAppSelector(selectPrimaryCalculatorPaymentOptions);
    const { sellingPriceTooltipLabelValue } = useSellingPriceConfiguration();
    const sellingPriceTooltipLabel = includeFees
        ? t('Shared.Common.sellingPriceDisclaimerWithTaxLabel')
        : sellingPriceTooltipLabelValue;
    const msrpTooltipLabel = t('Shared.Common.msrpDisclaimerLabel');
    return (_jsx(PriceComponent, { allInPriceTooltipLabel: sellingPriceTooltipLabel, errorMessage: t('Pages.Bap.apiLoadingError'), hasError: !!error, height: ['auto', 'auto', undefined], horizontalAlignment: "center", isFetching: isFetching, msrpStartingFromTooltipLabel: msrpTooltipLabel, priceComponentStyles: priceComponentStyles, prices: prices, alignItems: undefined, saveAboveLabel: undefined, suppressDiscount: undefined, showSellingPriceDisclaimer: undefined, frieghtPDIFeesCost: undefined, isLoadingIconLarge: true, errorIconName: "exclamationAlert", priceFormatter: priceFormatter, overrideShowSellingPrice: isSellingPriceProvince, loadingIconHeight: "28px", dealerFee: undefined, showRebateDisclaimerIndicator: false }));
};
export default CardPricing;
